<div class="dokladova-rada">
   <cml-panel-buttons [buttons]="buttons"></cml-panel-buttons>
  </div>

  <div *ngIf="!isComparation" class="detail-table">
    <cml-dokladova-rada-tabulka></cml-dokladova-rada-tabulka>
  </div>
  <ng-container *ngIf="isComparation">
    <div class="flex-container">
      <div class="fst-compared-table">
        <cml-dokladova-rada-tabulka [isComparation]="true"></cml-dokladova-rada-tabulka>
      </div>
      <div class="snd-compared-table">
        <cml-dokladova-rada-tabulka [compareKodUj]="compareKodUj" [compareKodUo]="compareKodUo" [isComparation]="true"></cml-dokladova-rada-tabulka>
      </div>
    </div>
  </ng-container>
<cml-extended-detail></cml-extended-detail>
